import React from 'react';
import { authHeader } from '../../_helpers/auth-header';
import { url } from '../../_services/apiurl';
import { createVideoApi } from './api';
import VideoSupport, { VideoNotifications } from './VideoSupport';
const api = createVideoApi(process.env.REACT_APP_VIDEO_SUPPORT_API_URL || url, authHeader);
export default function VideoSupportPage() {
  return <VideoSupport api={api} admin inviteBaseUrl={process.env.REACT_APP_VIDEO_SUPPORT_FRONTEND_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://myuaestartup.com')} />;
}
export function VideoSupportNotification() {
  return <VideoNotifications api={api} />;
}
